module.exports = __webpack_public_path__ + "static/media/img4.85f56886.PNG";